export class UserSignUpRequest {

    public firstName: string;    
    public lastName: string;
    public emailAddress: string;
}

export class UserSignUpResponse {

    public id: string;
    public firstName: string;    
    public lastName: string;
    public emailAddress: string;
    public isProvisional: boolean;
    
}